import app from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import firebase from 'firebase';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export class Firebase {
  private app: firebase.app.App;
  public database: firebase.database.Database;
  public firestore: firebase.firestore.Firestore;
  private analytics: firebase.analytics.Analytics | null;
  constructor() {
    this.app = app.initializeApp(config);
    this.database = this.app.database();
    this.firestore = this.app.firestore();
    this.analytics =
      (process.env.NODE_ENV === 'production'
        ? this.app.analytics()
        : null);
  }

  public logEvent(name: string): void {
    if (!this.analytics) {
      return;
    }
    const appType: string = process.env.REACT_APP_TYPE || 'unknown';
    let logName = `${appType}.${name}`;
    this.analytics.logEvent(logName);
  }
}
